import React, { useState, useEffect } from 'react';


const AIVisitorPopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isTyping, setIsTyping] = useState(true);
    const [message, setMessage] = useState('');
    const [visibleOptions, setVisibleOptions] = useState([]);

    const options = [
        { path: 'https://workspace.abiatechhub.com', label: 'Book a Co-working Space', external: true },
        { path: 'https://academy.abiatechhub.com', label: 'Learn Tech Skills', external: true },
        { path: 'https://academy.abiatechhub.com/talent-marketplace', label: 'Hire Tech talents', external: true },
        { path: 'https://cretehost.com', label: 'Buy a domain name and hosting', external: true },
        // { path: 'https://techflock.abiatechhub.com', label: 'Register for 2025 TechFlock', external: true },
        { path: '/contact', label: 'Web, Software development and consulting', external: false },
        { path: '/products', label: 'Explore our Products and services', external: false }
    ];

    useEffect(() => {
        // Check if user has previously skipped the AI and if it's still valid
        const skippedData = localStorage.getItem('ath_ai_skipped');
        const hasValidSkip = skippedData ? JSON.parse(skippedData) : null;

        const isSkipValid = hasValidSkip &&
            (new Date().getTime() - hasValidSkip.timestamp) < (24 * 60 * 60 * 1000); // 24 hours in milliseconds

        if (!isSkipValid) {
            // Clear expired skip data
            localStorage.removeItem('ath_ai_skipped');

            const timer = setTimeout(() => {
                setShowPopup(true);
                typeMessage("Welcome to Abia Tech Hub! What would you like to explore?");
            }, 2000);

            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showPopup]);

    const typeMessage = (text) => {
        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < text.length) {
                setMessage(text.substring(0, i + 1));
                i++;
            } else {
                clearInterval(typingInterval);
                setIsTyping(false);
                showOptionsSequentially();
            }
        }, 50);
    };

    const showOptionsSequentially = () => {
        options.forEach((_, index) => {
            setTimeout(() => {
                setVisibleOptions(prev => [...prev, index]);
            }, index * 500);
        });
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsTyping(true);
        typeMessage(`Great choice! Opening ${option.label} in a new tab...`);
        setTimeout(() => {
            if (option.external) {
                window.open(option.path, '_blank', 'noopener,noreferrer');
            } else {
                window.location.href = option.path;
            }
        }, 1500);
    };

    const handleClose = () => {
        // Save to localStorage with timestamp
        const skipData = {
            timestamp: new Date().getTime(),
            skipped: true
        };
        localStorage.setItem('ath_ai_skipped', JSON.stringify(skipData));
        setShowPopup(false);
        document.body.style.overflow = 'unset';
    };

    if (!showPopup) return null;

    return (
        <div className="ai-popup-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999
        }}>
                <div className="ai-popup-container" style={{
                    background: '#0a0e27',
                    borderRadius: '16px',
                    padding: '25px',
                    width: '90%',
                    maxWidth: '450px',
                    boxShadow: '0 10px 30px rgba(10, 14, 39, 0.4)',
                    position: 'relative',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: '-30px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '500',
                        background: '#0a0e27',
                        padding: '5px 15px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(10, 14, 39, 0.3)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        whiteSpace: 'nowrap'
                    }}>
                    Abia Tech Hub AI Agent
                </div>

                <div className="ai-popup-header" style={{
                    marginBottom: '20px'
                }}>
                    <div className="ai-avatar" style={{
                        width: '45px',
                        height: '45px',
                        background: '#1a1f3c',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '15px',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
                    }}>
                        <i className="fas fa-robot" style={{ fontSize: '20px', color: 'white' }}></i>
                    </div>
                    <div className="ai-message" style={{
                        color: 'white',
                        fontSize: '16px',
                        lineHeight: '1.5',
                        fontWeight: '500'
                    }}>
                        <div className="typing-indicator">
                            {message}
                            {isTyping && <span className="typing-cursor" style={{
                                display: 'inline-block',
                                width: '2px',
                                height: '20px',
                                backgroundColor: '#ffffff',
                                marginLeft: '4px',
                                verticalAlign: 'middle',
                                animation: 'blink 1s infinite'
                            }}>|</span>}
                        </div>
                    </div>
                </div>
                {!isTyping && !selectedOption && (
                    <div className="ai-options" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        marginTop: '20px'
                    }}>
                        {options.map((option, index) => (
                            <button
                                key={index}
                                className="ai-option-btn"
                                onClick={() => handleOptionSelect(option)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    borderRadius: '10px',
                                    padding: '12px 18px',
                                    color: 'white',
                                    fontSize: '14px',
                                    cursor: 'pointer',

                                    textAlign: 'left',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    fontWeight: '500',
                                    letterSpacing: '0.2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    opacity: visibleOptions.includes(index) ? 1 : 0,
                                    transform: `translateY(${visibleOptions.includes(index) ? '0' : '10px'})`,
                                    transition: 'background 0.3s ease, color 0.3s ease, border-color 0.3s ease, opacity 0.5s ease, transform 0.5s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.transform = 'translateX(5px)';
                                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                    e.target.style.transform = visibleOptions.includes(index) ? 'translateX(0)' : 'translateY(10px)';
                                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                                }}
                            >
                                {option.label}
                                <i className="fas fa-chevron-right" style={{ fontSize: '12px', opacity: 0.7 }}></i>
                            </button>
                        ))}
                    </div>
                )}
                <div style={{
                    position: 'absolute',
                    bottom: '-40px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <button
                        onClick={handleClose}
                        style={{
                            background: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '20px',
                            padding: '8px 16px',
                            color: 'rgba(255, 255, 255, 0.8)',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                            e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                            e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                        }}
                    >
                        <i className="fas fa-times-circle"></i>
                        Skip AI Assistant
                    </button>
                </div>
                <button
                    className="ai-close-btn"
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'rgba(255, 255, 255, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'rgba(255, 255, 255, 0.7)',
                        cursor: 'pointer',
                        fontSize: '16px',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                        e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                    }}
                >
                    <i className="fas fa-times"></i>
                </button>
            </div>
        </div>
    );
};

export default AIVisitorPopup;
